import '.fu{width:2.5rem;}.ssr-plugin'
import '.cj{height:2.5rem;}.ssr-plugin'
import '.g2{border-radius:10px;}.ssr-plugin'
import '.g3{background:var(--palette-blue-50);}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.ah{flex-shrink:0;}.ssr-plugin'
import { useQuery } from '@based/sdk/react'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { CardWrapper } from '@app/components/blocks/card/CardWrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faCheck } from '@fortawesome/pro-solid-svg-icons'
import { styled } from 'inlines'
import { useMemo } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import type {
  RawPlotRegistryItem,
  ActivePlotRegistryItem,
} from 'functions/app/plot-registry/list-active'
import { PlotRegistryStepTemplate } from './PlotRegistryStepTemplate'

type WelcomeStepProps = {
  selectedPlotRegistry: ActivePlotRegistryItem | null
  onSelect: (plotRegistry: ActivePlotRegistryItem) => void
}

export const WelcomeStep = ({
  selectedPlotRegistry,
  onSelect,
}: WelcomeStepProps) => {
  const t = useTranslations().app.plotRegistry.welcome
  const { data: rawData } = useQuery('list-active-plot-registries', {})

  const plotRegistries = useMemo(() => {
    if (!rawData) {
      return []
    }
    return (rawData as RawPlotRegistryItem[])
      .filter((k) => k.applicationWindows && k.applicationWindows.length > 0)
      .map((k) => ({
        ...k,
        applicationWindow: k.applicationWindows[0],
      }))
  }, [rawData])

  return (
    <PlotRegistryStepTemplate
      leftGap="1rem"
      rightGap="0.75rem"
      leftStyle={{ width: '50%' }}
      rightStyle={{ width: '50%' }}
      left={
        <>
          <Title.Page styledAsLevel={3}>{t.title}</Title.Page>
          <Text.Medium>{t.description}</Text.Medium>
        </>
      }
      right={
        <>
          <Text.Small
            style={{ color: 'var(--brand-secondary)', fontWeight: 400 }}
          >
            {t.selectMunicipality}
          </Text.Small>
          {plotRegistries.map((item) => {
            const isSelected = selectedPlotRegistry?.id === item.id
            return (
              <CardWrapper
                key={item.id}
                onClick={() => onSelect(item)}
                style={{
                  border: isSelected
                    ? '1px solid var(--brand-secondary)'
                    : '1px solid var(--palette-blue-100)',
                  cursor: 'pointer',
                  width: '100%',
                }}
              >
                <Row
                  style={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Row gap="0.75rem" style={{ alignItems: 'center' }}>
                    <div className="fu cj g2 g3 d r ab ah"
                    >
                      <FontAwesomeIcon
                        icon={faLocationDot}
                        style={{
                          color: 'var(--palette-blue-500)',
                          fontSize: '1.5rem',
                        }}
                      />
                    </div>
                    <Column gap={0}>
                      <Text.Medium isBold>
                        {item.municipality?.name ?? item.title}
                      </Text.Medium>
                      <Text.ExtraSmall
                        style={{ color: 'var(--palette-blue-600)' }}
                      >
                        {t.municipality}
                      </Text.ExtraSmall>
                    </Column>
                  </Row>
                  {isSelected && (
                    <FontAwesomeIcon
                      icon={faCheck}
                      style={{ color: 'var(--palette-blue-500)' }}
                    />
                  )}
                </Row>
              </CardWrapper>
            )
          })}
        </>
      }
    />
  )
}
